import React, { useReducer } from 'react'
import LoginContext from "./LoginContext";
import LoginReducer from "./LoginReducer";
import { useNavigate } from 'react-router-dom';
import { APP_VERSION, havePermission, setUserData } from '../../helpers/helpers';
import { sendResetPasswordService, loginService, sendNewPasswordService, loginCCService } from '../../services/login';
import { t } from 'i18next';
import { getSettingMenuService } from '../../services/Settings';
import { getPermissionsService } from '../../services/permissions';
import i18n from '../../i18n';

const LoginState = ({ children }) => {

    const InitialState = {
        login: {
            user: null,
            isFetching: false,
            error: false,
            message: '',
        },
        forgotPassword: {
            isFetching: false,
            error: false,
            message: '',
            user: null,
            wasReSend: false
        },
    }

    const [state, dispatch] = useReducer(LoginReducer, InitialState)

    const navigate = useNavigate();

    const cleanAlerts = () => {
        dispatch({ type: 'CLEAR_ALERTS' })
    }

    const loginSession = async (user) => {
        try {
            dispatch({ type: 'IS_FETCHING_LOGIN' });
            const response = await loginService(user);
            response.data.response = { ...response.data.response, version: APP_VERSION, year: new Date().getFullYear().toString() }
            if (response.ok) {

                i18n.changeLanguage(response.data.response.lang);

                setUserData(response.data.response);

                const permissions = await getPermissionsService();

                setUserData({ ...response.data.response, permissions: permissions.data.response });

                dispatch({
                    type: 'LOGIN',
                    payload: response.data.response
                })

                const canConfig = [9, 10, 11, 12].some(configPermission => havePermission(configPermission));

                if (canConfig) {
                    const menu = await getSettingMenuService();
                    localStorage.setItem('settingMenu', JSON.stringify(menu.data.response));

                };

                navigate('/selectAccessOpening');

            } else {
                switch (response.data.status) {
                    case 401:
                        dispatch({
                            type: 'LOGIN_ERROR',
                            payload: t('ERROR_LOGIN_CREDENTIALS')
                        })
                        break;
                    default:
                        dispatch({
                            type: 'LOGIN_ERROR',
                            payload: t('SERVER_ERROR')
                        })
                        break;
                }
            }
        } catch (e) {
            dispatch({
                type: 'LOGIN_ERROR',
                payload: t('SERVER_ERROR')
            })
            console.log(e);
        }
    }

    const sendResetPassword = async (user) => {
        try {
            dispatch({ type: 'IS_FETCHING_FORGOT_PASSWORD' });
            const response = await sendResetPasswordService(user);
            if (response.ok) {
                dispatch({
                    type: 'FORGOT_PASSWORD',
                    payload: user
                })
                navigate('/resendMail');
            } else {
                switch (response.data.status) {
                    case 404:
                        dispatch({
                            type: 'FORGOT_PASSWORD_ERROR',
                            payload: t('WRONG_USER_ERROR')
                        })
                        break;
                    default:
                        dispatch({
                            type: 'FORGOT_PASSWORD_ERROR',
                            payload: t('SERVER_ERROR')
                        })
                        break;
                }
            }
        } catch (e) {
            console.log(e);
            dispatch({
                type: 'FORGOT_PASSWORD_ERROR',
                payload: t('SERVER_ERROR')
            })
        }
    }

    const reSendResetPassword = async (user) => {
        try {
            dispatch({ type: 'IS_FETCHING_FORGOT_PASSWORD' });
            const response = await sendResetPasswordService(user);
            if (response.ok) {
                dispatch({ type: 'RE_SEND_FORGOT_PASSWORD' })
            } else {
                dispatch({
                    type: 'FORGOT_PASSWORD_ERROR',
                    payload: t('SERVER_ERROR')
                })
            }
        } catch (e) {
            console.log(e);
            dispatch({
                type: 'FORGOT_PASSWORD_ERROR',
                payload: t('SERVER_ERROR')
            })
        }
    }

    const sendNewPassword = async (newPassword) => {
        try {
            dispatch({ type: 'IS_FETCHING_FORGOT_PASSWORD' });
            const response = await sendNewPasswordService(newPassword);
            if (response.ok) {
                dispatch({ type: 'CHANGE_PASSWORD' })
                navigate('/passwordHasChange');
            } else {
                dispatch({
                    type: 'FORGOT_PASSWORD_ERROR',
                    payload: t('SERVER_ERROR')
                })
            }
        } catch (e) {
            dispatch({
                type: 'FORGOT_PASSWORD_ERROR',
                payload: t('SERVER_ERROR')
            })
            console.log(e)
        }
    }

    const loginCC = async (token) => {
        try {
            const response = await loginCCService(token);
            if (response.ok) {

                response.data.response = { ...response.data.response, version: APP_VERSION, year: new Date().getFullYear().toString() }

                i18n.changeLanguage(response.data.response.lang);

                setUserData({ ...response.data.response, token });

                const permissions = await getPermissionsService();

                setUserData({ ...response.data.response, token, permissions: permissions.data.response });

                dispatch({
                    type: 'LOGIN',
                    payload: response.data.response
                })

                const canConfig = [9, 10, 11, 12].some(configPermission => havePermission(configPermission));

                if (canConfig) {

                    const menu = await getSettingMenuService();

                    localStorage.setItem('settingMenu', JSON.stringify(menu.data.response));
                };

                navigate('/selectAccessOpening');
            } else {
                navigate('/login');
            }
        } catch (e) {
            navigate('/login');
            console.log(e);
        }
    }

    return (
        <LoginContext.Provider
            value={{
                loginState: state,
                loginSession,
                cleanAlerts,
                sendResetPassword,
                reSendResetPassword,
                sendNewPassword,
                loginCC
            }}
        >
            {children}
        </LoginContext.Provider>
    )
}

export default LoginState